import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserLoginService } from '../Common/UserLoginService/userlogin.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private userLoginService: UserLoginService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const isAuthenticated = this.userLoginService.isAuthenticated();

    if (isAuthenticated) {
      return true;
    } else {
      console.log('Authentication Failed While Routing');
      this.router.navigate(['/login'], { queryParams: { redirectUrl: state.url } });
      return false;
    }
  }
}
